import React from 'react';
import { useAdoption } from '../../context/AdoptionContext';
import WalkthroughOverlay from './WalkthroughOverlay';
import AdoptionTooltip from './AdoptionTooltip';
import SetupBanner from './SetupBanner';
import Hotspot from './Hotspot';

/**
 * Master component that reads pageContent from AdoptionContext
 * and renders the appropriate adoption components for the current page.
 * Include once in the layout — it handles everything.
 */
function AdoptionRenderer() {
  const { pageContent, activeWalkthrough } = useAdoption();

  const contextual = pageContent?.contextual || [];
  const banners = contextual.filter(c => c.content_type === 'banner');
  const tooltips = contextual.filter(c => c.content_type === 'tooltip' || c.content_type === 'callout');
  const hotspots = contextual.filter(c => c.content_type === 'hotspot');

  return (
    <>
      {/* Banners render at top of content area */}
      {banners.map(b => <SetupBanner key={b.id} content={b} />)}

      {/* Tooltips attach to target selectors */}
      {tooltips.map(t => <AdoptionTooltip key={t.id} content={t} />)}

      {/* Hotspots pulse on target elements */}
      {hotspots.map(h => <Hotspot key={h.id} content={h} />)}

      {/* Walkthrough overlay (only when active) */}
      {activeWalkthrough && <WalkthroughOverlay />}
    </>
  );
}

export default AdoptionRenderer;
